import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { Text } from "$components";
import ProjectStatusBadge from "$containers/Projects/ProjectStatusBadge";
import { useStyles } from "../DataTable.styles";
import {
  EnumDataRowType,
  RenderCellProps,
  EnumBadgeType,
} from "../DataTable.type";
import EdbStatusBadge from "$containers/EDB/EdbStatusBadge";

export const RenderCell = ({
  type,
  value,
  link,
  row,
  badge,
  isDisabled,
}: RenderCellProps) => {
  const classes = useStyles();
  const valueRow = value(row) as any;
  const { title, subtitle, isLarge, noEllipsis, noTitle } = valueRow || {};

  const ellipsisClassName = !noEllipsis
    ? clsx(
        classes.ellipsis,
        isLarge ? classes.largeEllipsis : classes.normalEllipsis
      )
    : "";

  switch (type) {
    case EnumDataRowType.Link:
      return link ? (
        <Box className={ellipsisClassName}>
          <Link className={`${classes.tableLink}`} to={link(row)}>
            {title ?? valueRow}
          </Link>
          {subtitle && (
            <Typography
              variant="caption"
              component="p"
              className={ellipsisClassName}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      ) : null;

    case EnumDataRowType.Badge:
      return link ? (
        badge === EnumBadgeType.Edb ? (
          <EdbStatusBadge
            status={valueRow.status}
            approverName={valueRow.approverName}
            isDisabled={
              typeof isDisabled === "function" ? isDisabled(row) : isDisabled
            }
          />
        ) : badge === EnumBadgeType.Project ? (
          <ProjectStatusBadge
            status={valueRow}
            disabled={
              typeof isDisabled === "function" ? isDisabled(row) : isDisabled
            }
          />
        ) : null
      ) : null;

    case EnumDataRowType.EmptyLink:
      return (
        <Box
          className={`${classes.ellipsis} ${isDisabled ? "disabled" : ""}`}
          style={isDisabled ? { color: "#B3BAC5", opacity: 0.7 } : {}}
        >
          {noTitle ? (
            <Typography
              variant="caption"
              component="p"
              className={classes.ellipsis}
            >
              {title ?? valueRow}
            </Typography>
          ) : (
            <Text
              type="important"
              style={isDisabled ? { color: "#B3BAC5", opacity: 0.7 } : {}}
            >
              {title ?? valueRow}
            </Text>
          )}
          {subtitle && (
            <Typography
              variant="caption"
              component="p"
              className={classes.ellipsis}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      );
    default:
      return <>{valueRow}</>;
  }
};
